/** HR-вкладка ОО (26.08, владелец): субтабы вместо выпадающего меню —
 *  Сотрудники · Грейды · Ставки (сетка) · Зарплаты · Премии/штрафы
 *  (05.09, владелец: «ОО в таб HR нужен новый субтаб премии/штрафы»).
 *  03.10 (владелец: найм и увольнение в HR): «Сотрудники» — общий ростер
 *  screens/hr/StaffRoster; субтабы purple (A2 — sub-navigation), одной строкой
 *  (неактивная «Премии/штрафы» подписана короче; если не влезло — полоса листается
 *  вбок, активная докручивается в кадр), последний субтаб помнится (localStorage,
 *  в try/catch). onStaffChanged — board.reload:
 *  Грейды/Ставки/Премии сразу видят принятого или уволенного. */
import { useEffect, useRef, useState } from "react";
import type { BoardOperator } from "../../hooks/useOoDay";
import type { DateRange } from "../../components/DateSelector";
import { StaffRoster } from "../hr/StaffRoster";
import { GradesTab } from "./GradesTab";
import { RatesMatrix } from "./RatesMatrix";
import { SalaryTab } from "./SalaryTab";
import { BonusPenaltyTab } from "./BonusPenaltyTab";
import { HoldTab } from "./HoldTab";
import css from "./hrHub.module.css";

const SUBTABS = [
  { id: "staff", label: "Сотрудники", short: "Сотрудники" },
  { id: "grades", label: "Грейды", short: "Грейды" },
  { id: "rates", label: "Ставки", short: "Ставки" },
  { id: "salary", label: "Зарплаты", short: "Зарплаты" },
  { id: "bonus", label: "Премии/штрафы", short: "Премии" },
  { id: "hold", label: "Холд", short: "Холд" },   // 16.10 (владелец): баланс операторов и выдачи
] as const;
type SubId = (typeof SUBTABS)[number]["id"];
const KEY = "ub_oo_hr_subtab";

function savedTab(): SubId {
  try {
    const v = localStorage.getItem(KEY);
    return SUBTABS.some((t) => t.id === v) ? (v as SubId) : "staff";
  } catch { return "staff"; }
}

export function HrHub({ operators, range, onStaffChanged }: { operators: BoardOperator[]; range: DateRange; onStaffChanged?: () => void }) {
  const [tab, setTabState] = useState<SubId>(savedTab);
  const navRef = useRef<HTMLElement>(null);
  useEffect(() => {
    navRef.current?.querySelector('[aria-current="page"]')?.scrollIntoView({ inline: "nearest", block: "nearest" });
  }, [tab]);
  const setTab = (t: SubId) => {
    setTabState(t);
    try { localStorage.setItem(KEY, t); } catch { /* приватный режим — просто не помним */ }
  };
  return (
    <div className={css.hub}>
      <nav ref={navRef} className={css.subtabs} aria-label="Разделы HR">
        {SUBTABS.map((t) => (
          <button key={t.id} type="button" aria-current={tab === t.id ? "page" : undefined}
            className={`${css.stab} ${tab === t.id ? css.on : ""}`} onClick={() => setTab(t.id)}>
            {tab === t.id ? t.label : t.short}
          </button>
        ))}
      </nav>
      {tab === "staff" ? <StaffRoster mode="oo" onChanged={onStaffChanged} />
        : tab === "grades" ? <GradesTab operators={operators} />
        : tab === "rates" ? <RatesMatrix operators={operators} />
        : tab === "salary" ? <SalaryTab range={range} />
        : tab === "hold" ? <HoldTab />
        : <BonusPenaltyTab operators={operators} range={range} />}
    </div>
  );
}
